import { Text } from '@components/primitives/Text'

export const NovelUsesSummary = ({
  drugNovelUsesSummary,
}: {
  drugNovelUsesSummary: string | null
}) => {
  if (!drugNovelUsesSummary) {
    return null
  }

  return (
    <Text
      className='my-2 text-dark'
      styleName={'p-small'}
      value={drugNovelUsesSummary}
    />
  )
}
